export const filterSeparator = "@@@";